export default __webpack_public_path__ + "static/media/logo.55a8df98.svg";